import { render } from "./Picklists.vue?vue&type=template&id=0a1d62c4"
import script from "./Picklists.vue?vue&type=script&lang=js"
export * from "./Picklists.vue?vue&type=script&lang=js"

import "./Picklists.vue?vue&type=style&index=0&id=0a1d62c4&lang=css"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__